import { Region } from '@ftr/contracts/type/court'

export const COUNTRY_TO_REGION: Record<string, Region> = {
  US: Region['us-west-2'],
  CA: Region['ca-central-1'],
  AU: Region['ap-southeast-2'],
  GB: Region['eu-west-2'],
}
